import { TableColumns } from "../../../../core/models/dashboard/tableColumns";

export const columns: TableColumns[] = [
  {
    header: "In Hands<br/>Date",
    field: "inHandsDate",
    link: false,
    linkField: "salesId",
    isDate: true,
    isNumber: false,
  },

  {
    header: "Order #",
    field: "orderNumber",
    link: true,
    linkField: "orderNumber",
    isDate: false,
    isNumber: false,
  },

  {
    header: "% Cost In",
    field: "costIn",
    link: true,
    linkField: "invoiceReviewSummaryScreen",
    isDate: false,
    isNumber: true,
    isPercentageSymbol: true,
  },

  {
    header: "Client",
    field: "clientName",
    link: true,
    linkField: "customerAccount",
    isDate: false,
    isNumber: false,
  },

  {
    header: "Job Name",
    field: "rsmJobName",
    link: true,
    linkField: "orderNumber",
    isDate: false,
    isNumber: false,
    isLongValueTrimmed: true,
  },

  {
    header: "Split",
    field: "split",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
  },

  {
    header: "Total <br/>Merch $",
    field: "totalMerch",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
    isCurrencySymbol: true,
  },

  {
    header: "% Costs",
    field: "orderPercentComplete",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
    isPercentageSymbol: true,
  },
  // {
  //   header: 'Invoice Proposal',
  //   field: 'rsmSplitInvoice',
  //   link: false,
  //   linkField: '',
  //   isDate: false,
  //   isNumber: false
  // },

  {
    header: "Customer<br/>Account",
    field: "customerAccount",
    link: true,
    linkField: "customerAccount",
    isDate: false,
    isNumber: false,
  },

  {
    header: "Billing Note",
    field: "rsmBillingNote",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: false,
  },

  {
    header: "BC",
    field: "bcId",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: false,
  },

  {
    header: "Total<br/>Sell $",
    field: "totalSell",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
    isCurrencySymbol: true,
  },

  {
    header: "Total<br/>Cost $",
    field: "totalCost",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
    isCurrencySymbol: true,
  },

  {
    header: "Matched AP<br/>Cost $",
    field: "matchedAPCost",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
    isCurrencySymbol: true,
  },

  {
    header: "Pay<br/>Method",
    field: "paymMode",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: false,
  },

  {
    header: "Billed<br/>Cost $",
    field: "billedCost",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
    isCurrencySymbol: true,
  },

  {
    header: "Unbilled<br/>Cost $",
    field: "unbilledCost",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
    isCurrencySymbol: true,
  },

  {
    header: "Last Vendor<br/>Invoice Date",
    field: "lastVendorInvoiceDate",
    link: false,
    linkField: "",
    isDate: true,
    isNumber: false,
  },

  {
    header: "First Vendor<br/>Invoice Date",
    field: "vsiJNIInvoiceDate",
    link: false,
    linkField: "",
    isDate: true,
    isNumber: false,
  },

  {
    header: "Margin $",
    field: "margin",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
    isCurrencySymbol: true,
  },

  {
    header: "Gross<br/>Margin $",
    field: "grossMargin",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
    isCurrencySymbol: true,
  },

  {
    header: "Freight<br/>Method",
    field: "freightMethod",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: false,
  },

  {
    header: "Freight<br/>Sales $",
    field: "freightSales",
    link: true,
    linkField: "freightSales",
    isDate: false,
    isNumber: true,
    isCurrencySymbol: true,
  },

  {
    header: "% of<br/>Freight",
    field: "percentageOfFreight",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
    isPercentageSymbol: true,
  },

  {
    header: "Sales<br/>Tax $",
    field: "salesTax",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
    isCurrencySymbol: true,
  },

  {
    header: "Freight<br/>Matched %",
    field: "freightMatchedPercent",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
    isPercentageSymbol: true,
  },

  {
    header: "Prev<br/>Billed $",
    field: "prevBilledAmt",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
    isCurrencySymbol: true,
  },

  {
    header: "Prebill $",
    field: "prebillAmt",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
    isCurrencySymbol: true,
  },

  {
    header: "Project Id",
    field: "projId",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: false,
  },
];
